// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallSentiments_title__i2g6t {
  font-size: 1.125rem;
}

.CallSentiments_percentage__se6BU {
  font-size: 1.125rem;
}

.CallSentiments_label__EA1RR {
  font-size: 0.75rem;
}

.CallSentiments_description__ihUbb {
  font-size: 0.75rem;
}

@media screen and (min-width: 75em) {
  .CallSentiments_title__i2g6t {
    font-size: 1.5rem;
  }
  .CallSentiments_percentage__se6BU {
    font-size: 1.5rem;
  }
  .CallSentiments_label__EA1RR {
    font-size: 0.875rem;
  }
  .CallSentiments_description__ihUbb {
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/reporting/components/CallSentiments.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE;IACE,iBAAA;EACF;EAEA;IACE,iBAAA;EAAF;EAGA;IACE,mBAAA;EADF;EAIA;IACE,eAAA;EAFF;AACF","sourcesContent":[".title {\n  font-size: 1.125rem;\n}\n\n.percentage {\n  font-size: 1.125rem;\n}\n\n.label {\n  font-size: 0.75rem;\n}\n\n.description {\n  font-size: 0.75rem;\n}\n\n@media screen and (min-width: 75em) {\n  .title {\n    font-size: 1.5rem;\n  }\n\n  .percentage {\n    font-size: 1.5rem;\n  }\n\n  .label {\n    font-size: 0.875rem;\n  }\n\n  .description {\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `CallSentiments_title__i2g6t`,
	"percentage": `CallSentiments_percentage__se6BU`,
	"label": `CallSentiments_label__EA1RR`,
	"description": `CallSentiments_description__ihUbb`
};
export default ___CSS_LOADER_EXPORT___;
